import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
    }
}

export default function RouteTracker() {
    const location = useLocation();

    useEffect(() => {
        window.gtag?.("config", "AW-18051920201", {
            page_path: location.pathname,
        });
    }, [location]);

    return null;
}